<template>
    <div v-if="data && data.id && !data.hide" :class="['notify', shit$(`dis:f; pt:17px; pb:24px; pl:25px;`)]">
        <div :class="shit$(`w:25px; h:25px; mr:25px;`)">
            <!-- <svg-icon :href="data.svg"></svg-icon> -->
            <img :src="`${env$ + data.href}`" :class="[shit$(`w:25px; h:25px;`), data.progress !== 100 && shit$(`animation: rotating 2s linear infinite;`)]" />
        </div>
        <div>
            <h1 :class="shit$(`font:16px; font-w:500; margin:0px; mb:6px;`)">{{ data.title }}</h1>
            <p :class="shit$(`font:12px; lh:1.5;`)">
                <span :class="shit$(`dis:i-b; w:24px; text-a:l;`)" v-if="!data.hidePercent && Number(handleFormat(data.progress)) < 100">
                    {{ handleFormat(data.progress) }}
                </span>
                <span>{{ data.content }}</span>
            </p>
            <!-- <p>{{ data.id }}</p> -->
        </div>
        <i @click="() => remove(data)" :class="['el-icon-close', shit$(`absolute; right:14px; top:14px; cursor:p; font:14px;`)]"></i>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
    props: {
        data: Object
    },
    computed: {
        ...mapState('notifySystem', { openFile: 'openFile', notifyInstance: 'notifyInstance' }),
        ...mapState(["env$"]),
    },
    methods: {
        ...mapActions('notifySystem', { hideAct$: 'hide' }),
        handleFormat (num) {
            const mapping = { 1: '00', 2: '0' }
            return mapping[String(num).length] + num || num
        },
        remove ({ id }) {
            const index = this.notifyInstance.findIndex(f => f.id === id)
            window.clearInterval(this.notifyInstance[index].timer)
            this.hideAct$({ id })
            
        },
        openTimerTerval ({ notifyId, timer = 50 }) {
            const index = this.notifyInstance.findIndex(f => f.id === notifyId)
            let clearInter = setInterval(() => {
                
                if (!this.notifyInstance[index]) return
                
                if (this.notifyInstance[index].progress >= 80) {
                    return window.clearInterval(this.notifyInstance[index].timer)
                }
                this.$store.commit("notifySystem/update", { id: notifyId, notify: { progress: this.notifyInstance[index].progress + 1 } })
            }, timer)
            this.$store.commit('notifySystem/update', { id: notifyId, notify: { timer: clearInter } })
        },
    },
}
</script>

<style scoped>
    .notify {
        width: 400px;
        height: 88px;
        color: #ffffff;
        font-size: 18px;
        position: relative;
        right: 0px;
        margin-bottom: 10px;
        background-color: #444444;

        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        

        
    }
</style>
